import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from "./shared/components/toast-container/toast-container.component";
import { HeaderComponent } from './shared/header/header.component';
import { AskExpartService } from '../app/shared/askexpart/askexpart.service';
import { AskexpartComponent } from '../app/shared/askexpart/askexpart.component';
import { NgIf,NgClass  } from '@angular/common';
import { FcmService } from './fcm.service';
import { NotificationService } from './core/services/notification.service';
import { UserNetworkService } from './features/auth/services/global.services';
import { SidebarService } from './core/services/sidebar.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent, NgIf, NgClass, HeaderComponent ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'frontend';
  isUser = false;
  reloadInterval : any;

  constructor(private sidebarService: SidebarService,public userNetworkInfo : UserNetworkService,private aroute: ActivatedRoute,public aiService: AskExpartService, public router: Router, private firebaseMsg: FcmService,private notificationService: NotificationService) {

    this.firebaseMsg.requestPermissionAndToken();
    this.firebaseMsg.listenToMessages();
    this.sidebarService.toggle();
  } 

  // Optionally define routes where header should be hidden
  hideHeaderRoutes: string[] = ['/', '/otp', '/auth', 'dashboard', 'register', 'login', 'import']; // customize these
  get showHeader(): boolean {
    const cleanUrl = this.router.url.split('?')[0];
    return !this.hideHeaderRoutes.includes(cleanUrl);
  }

  ngOnInit(): void {

    // var userInfoLocalStorage = localStorage.getItem('userInfo');
    //   if((this.userNetworkInfo.getUser() == null && userInfoLocalStorage == null) || userInfoLocalStorage == ''){
    //       this.router.navigateByUrl('http://localhost:4200?logout=true');
    //       return;
    //   }else{
        
    //     setTimeout(() => {
    //       this.isUser = true;
    //       this.router.navigate(['/dashboard']);
    //     }, 3000);
        
    //   }

    this.aroute.queryParams.subscribe(params => {
            const peramToken = params['logout'];

            if(params['logout'] && peramToken){
                localStorage.removeItem('userInfo');
                //alert("removed")

                this.router.navigate(['/'], {
                  queryParams: {},
                  replaceUrl: true
                });

                this.router.navigate(['/']);
            }

    });

   
    this.notificationService.fetchUnreadCount();

     // Listen for postMessage from Service Worker
    navigator.serviceWorker?.addEventListener('message', (event: any) => {
      if (event?.data?.type === 'NEW_NOTIFICATION') {
        console.log('Background FCM notification received');

        // Refresh unread count
        this.notificationService.refresh();
      }
    });

    this.reloadInterval = setInterval(() => {
      location.reload();
    }, 1800000);
 
    this.startTimer();

  }

   startTimer(): void {
    console.log('Timer restarted');
  }
 
}
